import styles from '../styles/checkboxSwitch.module.scss';

function CheckboxSwitch(props: {
  id: string;
  checked: boolean;
  name: string;
  children: string;
  disabled?: boolean;
  handler: (e: any) => void;
}) {
  return (
    <div className={styles.checkboxSwitch}>
      <label htmlFor={props.id}>{props.children}</label>
      <input
        type="checkbox"
        id={props.id}
        name={props.name}
        checked={props.checked}
        onChange={props.handler}
        disabled={props.disabled}
      />
    </div>
  );
}

export default CheckboxSwitch;
